import React, { useContext } from 'react'
import './moneyReports.css'
import { useTranslation } from 'react-i18next';
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import { Link } from 'react-router-dom'
import AuthContext from 'contexte/AuthContext'
import { ReportHeader } from './MoneyReportParts'

const REPORTS = [
  { to: '/reports/money/profits', title: 'Profits', hint: 'Revenus par jour ou par mois : trade, FX, structurés, margin, abonnements, retraits.' },
  { to: '/reports/money/profits-action', title: 'Profits par action', hint: 'Commissions par période, détaillées par ticker.' },
  { to: '/reports/money/expenses', title: 'Dépenses', hint: 'Coûts par jour : frais de change, brokers, Stripe, affiliation, cadeaux, overnight.' },
  // réservé aux rôles 1 et 2 (même liste que la route dans App.js)
  { to: '/reports/money/discounts', title: 'Réductions', hint: 'Réductions accordées sur les frais, par jour et par origine (abonnement, campagne...).', roles: [1, 2] },
]

const Money = () => {
  const { t } = useTranslation();
  const { verifyUser } = useContext(AuthContext);
  const { role } = verifyUser();

  return (
    <DashboardLayout page={t("pages_name.report_money")}>
      <div className='money_report_page'>
        <ReportHeader title={t("pages.report_money.title")} />
        <ul className='money_report_links'>
          {REPORTS.filter(report => !report.roles || report.roles.includes(role)).map(report => (
            <li key={report.to}>
              <Link className='money_report_link' to={report.to}>
                <span className='money_report_link_title'>{report.title}</span>
                <span className='money_report_link_hint'>{report.hint}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </DashboardLayout>
  )
}

export default Money
